<template>
    <transition
        name="fade-grid"
        mode="out-in"
    >
        <slot></slot>
    </transition>
</template>

<style lang="scss" scoped>
.fade-grid-leave-active {
    transition: opacity 60ms var(--timing-function-easing-decelerate) !important;
}

.fade-grid-enter-active {
    transition: opacity 280ms var(--timing-function-easing-accelerate) !important;
}

.fade-grid-enter-from,
.fade-grid-leave-to {
    opacity: 0 !important;
}
</style>
